<template>
  <div class="assessment-journey">
    <assessment-journey-tab @clickedTab="selectedTab" :showRecAssessmentJourneyUI="showRecAssessmentJourneyUI"></assessment-journey-tab>
    <div class="main-content" v-if="!isUserGroupAdmin && (currentSelectedTab === 1)">
      <assessment-journey-search-bar @clickedCreateAssessment="showHideCreateAssessmentComponent" @checkAndShowAssessmentList="updateIsAssessmentListPresentForFilteredResultFlag" v-bind:newlyCreatedAssessmentObj="getNewAssessmentObj"></assessment-journey-search-bar>
      <create-assessment-journey v-if="showCreateAssessmentUI" @clickedCreateAssessment="showHideCreateAssessmentComponent" @showSpinner="updateShowSpinnerFlag" @newCreatedAssessmentObj="passNewlyCreatedAssessmentObj"></create-assessment-journey>
      <create-assessment v-if="AssessmentListPresentForFilteredResult" @showSpinner="updateShowSpinnerFlag"></create-assessment>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
    </div>
    <div class="main-content" v-if="!isUserGroupAdmin && (currentSelectedTab === 2)">
      <course-search-bar @clickedCreateCourse="showHideCreateCourseComponent" @checkAndShowLessonList="updateIsLessonListPresentForFilteredResultFlag" v-bind:newlyCreatedCourseObj="getNewCourseObj" :isComingFrom="constants.CourseSearchBarEnum.AssessmentJourney"></course-search-bar>
      <create-course v-if="showCreateCourseUI" @clickedCreateCourse="showHideCreateCourseComponent" @showSpinner="updateShowSpinnerFlag" @newCreatedCourseObj="passNewlyCreatedCourseObj"></create-course>
      <create-lesson v-if="LessonListPresentForFilteredResult" @showSpinner="updateShowSpinnerFlag" :isComingFrom="constants.CourseSearchBarEnum.AssessmentJourney"></create-lesson>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>
  </div>
</template>

<script>
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import { assessmentService } from '@/server-util/assessment-service'
import AssessmentSearchBar from '@/components/assessment_journey/AssessmentSearchBar'
import CreateAssessment from '@/components/assessment_journey/CreateAssessment'
import AlertBox from '@/components/AlertOverlay'
import CopyrightElement from '@/components/CopyrightElement'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
import { courseService } from '@/server-util/course-service'
import CourseSearchBar from '@/components/CourseSearchBar'
import CreateCourse from '@/components/CreateCourse'
import CreateLesson from '@/components/CreateLesson'
import { masterTopicService } from '@/server-util/master-topic-service'
import AssessmentJourneyTab from '../components/AssessmentJourneyTab.vue'
require('bootstrap/dist/css/bootstrap.min.css')
export default {
  created () {
    this.getCourses()
    this.getAssessmentList()
    this.trackPageLoad()
    this.checkUserErrorStatus()
    this.readQueryParam()
  },
  data: function () {
    return {
      constants: constants,
      currentSelectedTab: 1,
      showCreateAssessmentUI: false,
      AssessmentListPresentForFilteredResult: false,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      newlyCreatedAssessmentObj: null,
      showRecAssessmentJourneyUI: true,
      showCreateCourseUI: false,
      LessonListPresentForFilteredResult: false,
      newlyCreatedCourseObj: null
    }
  },
  components: {
    'course-search-bar': CourseSearchBar,
    'create-course': CreateCourse,
    'create-lesson': CreateLesson,
    'assessment-journey-search-bar': AssessmentSearchBar,
    'create-assessment-journey': CreateAssessment,
    'create-assessment': CreateAssessment,
    'alert-box': AlertBox,
    'Copyright-Element': CopyrightElement,
    'error-page': ErrorPage,
    'loader': Loader,
    'assessment-journey-tab': AssessmentJourneyTab
  },
  name: 'assessment-journey',
  methods: {
    selectedTab (value) {
      // AK: Hide list when user selects different option than current
      if (this.currentSelectedTab !== value) {
        this.currentSelectedTab = value
      }
    },
    getTopicList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
      ) {
        masterTopicService
          .getAllMasterTopicList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.masterTopicList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING TOPIC LIST'
        )
      }
    },
    passNewlyCreatedCourseObj (value) {
      // AK: Store newly create course obj and pass it to course search bar
      if (value.isCourseCreated) {
        this.newlyCreatedCourseObj = value.newCreatedCourseObj
      }
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.course_list.length === 0) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
      }

      courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.course_list = responseObj.data
              // this.showSpinner = false
              this.$store.state.isLoading = false
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
    },
    showHideCreateCourseComponent (value) {
      this.showCreateCourseUI = value
    },
    updateIsLessonListPresentForFilteredResultFlag (value) {
      var storeObj = this.$store
      this.LessonListPresentForFilteredResult = value // storeObj.state.selectedMasterClassModuleList.length !== 0
      if (storeObj.state.selectedMasterClassModuleList.length === 0) {
        this.showAlertDialog = true
        var selectedCourseObj = storeObj.state.selectedCourseObjFromFilter
        this.errorMsg =
          'No Lesson(s) found in selected \'' +
          selectedCourseObj.CourseTitle +
          '\' assessment.'
      }
    },
    readQueryParam: function () {
      const courseId = this.$route.query.courseId
      if (courseId !== undefined && courseId !== 'undefined' && courseId !== null && courseId !== 'null' && courseId !== '') {
        this.showRecAssessmentJourneyUI = false
        this.currentSelectedTab = 2
      } else {
        this.currentSelectedTab = 1
      }
      if (!this.showRecAssessmentJourneyUI) {
        this.getTopicList()
        this.getCourses()
        this.trackPageLoad()
        this.checkUserErrorStatus()
      }
    },
    getAssessmentList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
      ) {
        // AK: Check whether list is already present or not?
        if (storeObj.state.assessmentList.length === 0) {
          _this.$store.state.isLoading = true
        }
        assessmentService
          .getAllAssessmentList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.assessmentList = responseObj.data.AssessmentList
              storeObj.state.recAssessmentList = responseObj.data.CoursemasterList
              _this.$store.state.isLoading = false
            } else {
              if (_this.$store.state.isLoading === true) {
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING ASSESSMENT LIST'
        )
      }
    },
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    passNewlyCreatedAssessmentObj (value) {
      // AK: Store newly create assessment-journey obj and pass it to assessment-journey search bar
      if (value.isCourseCreated) {
        this.newlyCreatedAssessmentObj = value.newCreatedAssessmentObj
      }
    },
    showHideCreateAssessmentComponent (value) {
      this.showCreateAssessmentUI = value
    },
    updateIsAssessmentListPresentForFilteredResultFlag (value) {
      var storeObj = this.$store
      this.AssessmentListPresentForFilteredResult = value // storeObj.state.selectedAssessmentElementList.length !== 0
      if (storeObj.state.selectedAssessmentElementList.length === 0) {
        this.showAlertDialog = true
        var selectedAssessmentObj = storeObj.state.selectedAssessmentObjFromFilter
        this.errorMsg =
          'No step(s) found in selected "' +
          selectedAssessmentObj.AssessmentTitle +
          '" Assessment.'
      }
    },
    updateShowSpinnerFlag (value) {
      // AK: As Soon as User create request send to server show spinner and Hide spinner after recieving updated list
      this.$store.state.isLoading = value
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Manage Assessment Journey Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Assessment_Journey,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'MANAGE ASSESSMENT JOURNEY',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    },
    getNewAssessmentObj: {
      get: function () {
        return this.newlyCreatedAssessmentObj
      }
    },
    getNewCourseObj: {
      get: function () {
        return this.newlyCreatedCourseObj
      }
    }
  },
  watch: {
    $route (to, from) {
      this.readQueryParam()
    }
  }
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.assessment-journey {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.background-color-red {
  background-color: red;
}
.cf-border {
  border: 1px solid black;
}
.left-color-border {
  border: 1px solid red;
}
.right-color-border {
  border: 1px solid green;
}
.leftNavBarBG {
  background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px {
  font-size: 30px;
}
.position-Fixed {
  position: fixed;
}
.float-Right {
  float: right;
}
.fullHeight {
  height: 100% !important;
}
.fi-border {
  border: 1px solid white;
}
.footer-img {
  margin: 0 auto !important;
  display: block;
  position: absolute;
  bottom: 0;
  width: 30%;
}
.center-block {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.text-center {
  text-align: center;
}
.margin-Top-14Perc {
  margin-top: 14%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.margin-Top-5Perc {
  margin-top: 5%;
}
.admin-Panel-BG {
  background-color: #f39c12;
}
.text-align-left {
  text-align: left;
}
.margin-Left-4Perc {
  margin-left: 4%;
}
.admin-Panel-Padding {
  padding: 0.1% 0% 0.1% 2%;
}
.font-size-2vw {
  font-size: 2vw;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AssessmentJourney.vue